<table mat-table [dataSource]="dataSource$ | async" multiTemplateDataRows>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>{{ 'silos.siloName' | translate }}</th>
    <td mat-cell *matCellDef="let silo">{{ silo.name }}</td>
  </ng-container>
  <ng-container matColumnDef="siloNumber">
    <th mat-header-cell *matHeaderCellDef>{{ 'silos.siloNumber' | translate }}</th>
    <td mat-cell *matCellDef="let silo">{{ 'silo.silo-prefix' | translate }} {{ silo.siloNumber }}</td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef class="actions-header">{{ 'silos.actions' | translate }}</th>
    <td mat-cell *matCellDef="let silo" class="fixed-height">
      <div class="flex--row flex--justify-right flex--justify-space-between flex--align-center flex--nowrap">
        <button
          #openSiloAddProductsButton
          class="addProductButton"
          mat-button
          data-test="add-product"
          (click)="openProductDialog(silo); $event.stopPropagation()"
        >
          <mat-icon>add</mat-icon>
          <span *ngIf="breakpointService.gtXs$ | async">{{ 'silos.product-list.table-product-name' | translate }}</span>
        </button>

        <button mat-button (click)="editSilo(silo); $event.stopPropagation()">
          <mat-icon>edit</mat-icon>
        </button>

        <button mat-button (click)="deleteSilo(silo); $event.stopPropagation()">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="expand">
    <th mat-header-cell *matHeaderCellDef aria-label="row actions" class="expansion-header">&nbsp;</th>
    <td mat-cell *matCellDef="let silo">
      <button mat-icon-button aria-label="expand row" (click)="toggleExpand(silo.id); $event.stopPropagation()">
        <mat-icon *ngIf="!expandedSiloMap[silo.id]">keyboard_arrow_up</mat-icon>
        <mat-icon *ngIf="expandedSiloMap[silo.id]">keyboard_arrow_down</mat-icon>
      </button>
    </td>
  </ng-container>
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let silo" [attr.colspan]="columnsToDisplayWithExpand.length">
      <app-silos-product-list [siloId]="silo.id"></app-silos-product-list>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="(breakpointService.gtMd$ | async) ? columnsToDisplayWithExpand : columnsToDisplay" class="silo-header"></tr>
  <tr
    mat-row
    *matRowDef="let silo; columns: (breakpointService.gtMd$ | async) ? columnsToDisplayWithExpand : columnsToDisplay"
    class="silo-row spacing--margin-bottom"
    [class.expanded-row]="expandedSiloMap[silo.id]"
    (click)="toggleExpand(silo.id)"
  ></tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row spaceUnder"></tr>
  <tr style="height: 20px" *matRowDef="let row; columns: []"></tr>
  <!-- Spacer row -->
</table>
